import mock from './mock'

/* eslint-disable import/extensions */

// JWT
import './jwt'

// Table
// import './data/extensions/good-table'
// import './data/extensions/auto-suggest'
// import './data/card/card-statistics'
// import './data/card/card-analytics'

// Apps
import './data/apps/calendar'
import './data/apps/user'
import './data/apps/recruiter'
import './data/apps/jobs'
import './data/apps/candidate'
// import './data/apps/email'
// import './data/apps/invoice'
// import './data/apps/chat'
// import './data/apps/eCommerce'

// dashboard
// import './data/dashboard/analytics'
// import './data/dashboard/ecommerce'
import './data/dashboard/admin'
import './data/dashboard/recruiter'

// pages
// import './data/pages/faq-data'
// import './data/pages/knowledge-base'
// import './data/pages/pricing-data'
// import './data/pages/account-setting'
// import './data/pages/profile-data'
// import './data/pages/blog'
/* eslint-enable import/extensions */

// Explicit pass-through for production ATS endpoints that must never be mocked.
// (axios-mock-adapter still appears in stack traces when passThrough runs — that is normal.)
mock.onPost(/\/api\/offer-table-config\/generate-pdf/).passThrough()
mock.onAny().passThrough() // forwards the matched request over network
